import React from "react";

import Standard from "./standard/Standard";
import Notification from "./notification/Notification";
import Atlassian from "./atlassian/Atlassian";
import { DesignContainer } from "./styles";

const designComponents = {
  standard: Standard,
  notification: Notification,
  atlassian: Atlassian,
};

const Design = ({ data, isPreview = false, canEdit = false, text }) => {
  const DesignComponent = designComponents[data.style];

  return (
    <DesignContainer>
      <DesignComponent
        data={data}
        isPreview={isPreview}
        canEdit={canEdit}
        text={text}
      />
    </DesignContainer>
  );
};

export default Design;
